import React from 'react';
import PropTypes from 'prop-types';

const Tag = props => {
  const {text, color} = props
  return (
    <div className="tag flex">
      <div className={`s-px-4px s-py-2px small-radius s-cross-center nowrap s-bg-light-${color}`}>
        <div className={`s-h-6px s-w-6px circle-radius s-mr-2px s-bg-${color}`}/>
        <p className={`s-mb-0 smaller s-color-${color}`}>{text}</p>
      </div>
    </div>
  );
};

Tag.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
};

export default Tag;
